<div class="modal-header" *ngIf="!fromMasterScreen">
    <h2 class="modal-title" translate>lblSearchParts</h2>
    <button type="button" class="close" aria-label="Close" (click)="OnClose()">
        <span aria-hidden="true">×</span>
    </button>
</div>
<div class="sp" [ngClass]="fromMasterScreen ? 'p-0':'modal-body p-0 min-h500'">
    <!-- Search filters -->
    <div class="sp-search">
        <div class="sp-field sp-field--make">
            <label translate>lblMake</label>
            <ng-select placeholder="{{ 'lblSelectMake' | translate }}" [(ngModel)]="brandCode">
                <ng-option *ngFor="let type of makeList" [value]="type.brandCode">
                    {{type.brandCode}}</ng-option>
            </ng-select>
        </div>
        <div class="sp-field">
            <label for="sp-part-number" translate>lblPartNumber
                <strong class="required"> * </strong>
            </label>
            <input id="sp-part-number" class="form-control" [(ngModel)]="partNumber"
                placeholder="{{ 'lblEnterPartNumber' | translate }}" maxlength="20"
                (keyup.enter)="onSearchParts()">
        </div>
        <div class="sp-field sp-field--wide">
            <label for="sp-description" translate>lblDescription
                <strong class="required"> * </strong>
            </label>
            <input id="sp-description" class="form-control" [(ngModel)]="partDescription"
                placeholder="{{ 'lblDescription' | translate }}" maxlength="50"
                (keyup.enter)="onSearchParts()">
        </div>
        <button class="btn btn-primary sp-search-btn" type="button" (click)="onSearchParts()">
            <em class="fa fa-search"></em> Search
        </button>
    </div>

    <div class="sp-content">
        <!-- Already added parts -->
        <div class="ctm-tab custom-card card-accord">
            <ngb-accordion #accAdded="ngbAccordion" activeIds="alreadyAdded" class="main overflow-none-card">
                <ngb-panel id="alreadyAdded">
                    <ng-template ngbPanelHeader class="custom-header ctm">
                        <div class="d-flex align-items-center">
                            <button ngbPanelToggle class="btn d-flex w-100 align-items-center text-left py-1-5 sp-acc-head"
                                aria-label="Center Align">
                                <span>{{ 'lblAlreadyAddedParts' | translate }}</span>
                                <span class="sp-count ml-auto mr-2">{{ selectedPartList?.length || 0 }}</span>
                                <em class="fas fa-lg"
                                    [ngClass]="accAdded.activeIds.includes('alreadyAdded') ? 'fa-angle-up' : 'fa-angle-down'"></em>
                            </button>
                        </div>
                    </ng-template>
                    <ng-template ngbPanelContent>
                <div class="table-responsive max-h357" *ngIf="selectedPartList?.length>0; else noAlreadyAdded">
                    <table class="sp-table sp-table--compact">
                        <thead>
                            <tr>
                                <th scope="col" class="sp-col-index">#</th>
                                <th scope="col">{{ 'lblMakeCode' | translate }}</th>
                                <th scope="col">{{ 'lblPartNumber' | translate }}</th>
                                <th scope="col">{{ 'lblDescription' | translate }}</th>
                                <th scope="col" class="text-right">{{ 'lblQtyShort' | translate }}</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let appointment of selectedPartList; let i=index">
                                <td class="sp-col-index">{{ i+1 }}</td>
                                <td><span class="sp-make">{{appointment.makeCode}}</span></td>
                                <td class="sp-part-no">{{appointment.salesPart}}</td>
                                <td>{{appointment.description}}</td>
                                <td class="text-right sp-num">{{appointment.plannedQuantity | number: '1.2-2'}}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <ng-template #noAlreadyAdded>
                    <div class="sp-empty-inline">{{ 'lblNoRecordsFound' | translate }}</div>
                </ng-template>
                    </ng-template>
                </ngb-panel>
            </ngb-accordion>
        </div>

        <!-- Newly added parts -->
        <div class="ctm-tab custom-card card-accord" *ngIf="checkAddedNewParts">
            <ngb-accordion #accNew="ngbAccordion" activeIds="newlyAdded" class="main overflow-none-card">
                <ngb-panel id="newlyAdded">
                    <ng-template ngbPanelHeader class="custom-header ctm">
                        <div class="d-flex align-items-center">
                            <button ngbPanelToggle class="btn d-flex w-100 align-items-center text-left py-1-5 sp-acc-head"
                                aria-label="Center Align">
                                <span>{{ 'lblNewlyAddedParts' | translate }}</span>
                                <span class="sp-count sp-count--accent ml-auto mr-2">{{ selectedPartArray.length }}</span>
                                <em class="fas fa-lg"
                                    [ngClass]="accNew.activeIds.includes('newlyAdded') ? 'fa-angle-up' : 'fa-angle-down'"></em>
                            </button>
                        </div>
                    </ng-template>
                    <ng-template ngbPanelContent>
                <div class="table-responsive max-h357">
                    <table class="sp-table sp-table--compact">
                        <thead>
                            <tr>
                                <th scope="col" class="sp-col-index">#</th>
                                <th scope="col">{{ 'lblMakeCode' | translate }}</th>
                                <th scope="col">{{ 'lblPartNumber' | translate }}</th>
                                <th scope="col">{{ 'lblDescription' | translate }}</th>
                                <th scope="col" class="text-right">{{ 'lblPrice' | translate }}</th>
                                <th scope="col" class="text-right">{{ 'lblPriceInc' | translate }}</th>
                                <th scope="col" class="text-right">{{ 'lblUnitCost' | translate }}</th>
                                <th scope="col" class="text-right">{{ 'lblTotalQty' | translate }}</th>
                                <th scope="col" class="text-right">{{ 'lblAvlQty' | translate }}</th>
                                <th scope="col" class="text-right">{{ 'lblQtyShort' | translate }}</th>
                                <th scope="col" class="text-right">{{ 'lblAction' | translate }}</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let appointment of selectedPartArray; let i=index">
                                <td class="sp-col-index">{{ i+1 }}</td>
                                <td><span class="sp-make">{{appointment.makeCode}}</span></td>
                                <td class="sp-part-no">{{appointment.partNumber}}</td>
                                <td>{{appointment.description}}</td>
                                <td class="text-right sp-num">{{appointment.unitPrice | number: '1.2-2'}}</td>
                                <td class="text-right sp-num sp-strong">{{appointment.unitPriceInclVat | number: '1.2-2'}}</td>
                                <td class="text-right sp-num sp-muted">{{appointment.unitCost | number: '1.2-2'}}</td>
                                <td class="text-right sp-num">{{appointment.quantity | number: '1.2-2'}}</td>
                                <td class="text-right">
                                    <span class="sp-stock" [class.sp-stock--in]="appointment.availableQuantity > 0">
                                        {{appointment.availableQuantity | number: '1.2-2'}}
                                    </span>
                                </td>
                                <td class="text-right sp-num">{{appointment.qty | number: '1.2-2'}}</td>
                                <td class="text-right">
                                    <button type="button" class="sp-icon-btn sp-delete-btn"
                                        [ngbTooltip]="'lblDelete' | translate" tooltipClass="custom-revert" container="body"
                                        (click)="removeSelectedPart(appointment)">
                                        <em class="fas fa-trash-alt"></em>
                                    </button>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                    </ng-template>
                </ngb-panel>
            </ngb-accordion>
        </div>

        <!-- Search results -->
        <div [ngClass]="fromMasterScreen ? 'sp-results-card table-responsive' : 'sp-results-card sp-results table-responsive'">
            <table class="sp-table">
                <thead>
                    <tr>
                        <th scope="col" class="sp-col-check" *ngIf="!fromMasterScreen"></th>
                        <th scope="col" class="sp-col-icon" *ngIf="!fromMasterScreen"></th>
                        <th scope="col" translate>lblMake</th>
                        <th scope="col" translate *ngIf="isLocationNameVisible">lblLocationName</th>
                        <th scope="col" translate>lblPartNumber</th>
                        <th scope="col" class="text-right" translate>lblPrice</th>
                        <th scope="col" class="text-right" translate>lblPriceInc</th>
                        <th scope="col" class="text-right" translate>lblUnitCost</th>
                        <th scope="col" class="text-right" translate>lblTotalQty</th>
                        <th scope="col" class="text-right" translate>lblAvlQty</th>
                        <th scope="col" class="text-right sp-col-qty" *ngIf="!fromMasterScreen" translate>
                            lblQtyShort</th>
                        <th scope="col" class="text-center" *ngIf="isAnyActionFound && !fromMasterScreen" translate>
                            lblAction</th>
                    </tr>
                </thead>
                <tbody>
                    <ng-container *ngIf="partsList?.length>0; else load_NotFound_Template">
                        <ng-container *ngFor="let part of partsList; let i=index">
                            <tr class="sp-row" [class.is-selected]="part.isPartSelected"
                                [class.is-expanded]="part.expanded">
                                <td class="sp-col-check" *ngIf="!fromMasterScreen">
                                    <input type="checkbox" class="sp-check" [(ngModel)]="part.isPartSelected"
                                        (change)="selectPartOnChange($event,part)"
                                        [checked]="part.isPartSelected" />
                                </td>
                                <td class="sp-col-icon" (click)="part.expanded = !part.expanded"
                                    *ngIf="!fromMasterScreen">
                                    <button type="button" class="sp-icon-btn sp-avail-btn" [class.active]="part.expanded"
                                        ngbTooltip="Check Availability" tooltipClass="custom-revert" container="body"
                                        [attr.aria-expanded]="part.expanded"
                                        (click)="getPartLocation(part.partNumber,i)">
                                        <em class="fas fa-lg" [ngClass]="part.expanded ? 'fa-chevron-up' : 'fa-check-circle'"></em>
                                    </button>
                                </td>
                                <td><span class="sp-make">{{part.makeCode}}</span></td>
                                <td *ngIf="isLocationNameVisible" class="sp-muted">
                                    {{part.locationCode}} {{part.locationName}}
                                </td>
                                <td>
                                    <div class="sp-part-no">{{part.partNumber}}</div>
                                    <div class="sp-part-desc" [innerHTML]="part.description"></div>
                                </td>
                                <td class="text-right sp-num">{{part.unitPrice | number: '1.2-2'}}</td>
                                <td class="text-right sp-num sp-strong">{{part.unitPriceInclVat | number: '1.2-2'}}</td>
                                <td class="text-right sp-num sp-muted">{{part.unitCost | number: '1.2-2'}}</td>
                                <td class="text-right sp-num">{{part.quantity | number: '1.2-2'}}</td>
                                <td class="text-right">
                                    <span class="sp-stock" [class.sp-stock--in]="part.availableQuantity > 0">
                                        {{part.availableQuantity | number: '1.2-2'}}
                                    </span>
                                </td>
                                <td class="sp-col-qty" *ngIf="!fromMasterScreen">
                                    <input class="form-control sp-qty" type="text"
                                        [value]="part.qty " [(ngModel)]="part.qty" maxlength="10"
                                        (keypress)="isQtyPrice($event,part.qty)"
                                        (ngModelChange)="checkQty($event, i)" />
                                </td>
                                <td class="nowrap text-center" *ngIf="isAnyActionFound && !fromMasterScreen">
                                    <div class="sp-actions">
                                        <button type="button" class="sp-icon-btn" ngbTooltip="Additional Part"
                                            tooltipClass="custom-revert" *ngIf="part.hasAdditionalItems"
                                            (click)="GetAdditionalParts(contentAdditional,part)">
                                            <em class="icon-additional"></em>
                                        </button>
                                        <button type="button" class="sp-icon-btn" ngbTooltip="Alternate Part"
                                            tooltipClass="custom-revert" *ngIf="part.hasAlternativeItems"
                                            (click)="GetAlternativeParts(part)">
                                            <em class="icon-alternate"></em>
                                        </button>
                                        <button type="button" class="sp-icon-btn" ngbTooltip="Replacement"
                                            tooltipClass="custom-revert" *ngIf="part.hasReplacementItems"
                                            (click)="GetReplacementParts(part)">
                                            <em class="icon-replace"></em>
                                        </button>
                                    </div>
                                </td>
                            </tr>
                            <tr class="sp-subrow" *ngIf="part.expanded">
                                <td colspan="12">
                                    <div class="sp-sub">
                                        <table class="sp-table sp-table--compact">
                                            <thead>
                                                <tr>
                                                    <th scope="col" translate>lblMake</th>
                                                    <th scope="col" translate>lblLocationName</th>
                                                    <th scope="col" translate>lblPartNumber</th>
                                                    <th scope="col" translate>lblDescription</th>
                                                    <th scope="col" class="text-right" translate>lblPrice</th>
                                                    <th scope="col" class="text-right" translate>lblPriceInc</th>
                                                    <th scope="col" class="text-right" translate>lblUnitCost</th>
                                                    <th scope="col" class="text-right" translate>lblTotalQty</th>
                                                    <th scope="col" class="text-right" translate>lblAvlQty</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <ng-container
                                                    *ngIf="part.partLocationList?.length>0; else load_NotFoundPartLocations_Template">
                                                    <tr *ngFor="let loc of part.partLocationList; let j=index">
                                                        <td><span class="sp-make">{{loc.makeCode}}</span></td>
                                                        <td>{{loc.locationCode}} {{loc.locationName}}</td>
                                                        <td class="sp-part-no">{{loc.partNumber}}</td>
                                                        <td [innerHTML]="loc.description"></td>
                                                        <td class="text-right sp-num">{{loc.unitPrice | number: '1.2-2'}}</td>
                                                        <td class="text-right sp-num">{{loc.unitPriceInclVat | number: '1.2-2'}}</td>
                                                        <td class="text-right sp-num">{{loc.unitCost | number: '1.2-2'}}</td>
                                                        <td class="text-right sp-num">{{loc.quantity | number: '1.2-2'}}</td>
                                                        <td class="text-right">
                                                            <span class="sp-stock" [class.sp-stock--in]="loc.availableQuantity > 0">
                                                                {{loc.availableQuantity | number: '1.2-2'}}
                                                            </span>
                                                        </td>
                                                    </tr>
                                                </ng-container>
                                                <ng-template #load_NotFoundPartLocations_Template>
                                                    <tr>
                                                        <td colspan="9" class="sp-empty-inline" translate>
                                                            lblNoRecordsFound</td>
                                                    </tr>
                                                </ng-template>
                                            </tbody>
                                        </table>
                                    </div>
                                </td>
                            </tr>
                        </ng-container>
                    </ng-container>

                    <ng-template #load_NotFound_Template>
                        <tr>
                            <td colspan="12" class="sp-empty">
                                <em class="fas fa-search"></em>
                                <div translate>lblChangeSearchCriteria</div>
                            </td>
                        </tr>
                    </ng-template>
                </tbody>
            </table>
        </div>
    </div>
</div>
<div class="modal-footer sp-footer" *ngIf="!fromMasterScreen">
    <span class="sp-footer-info" *ngIf="checkAddedNewParts">
        <em class="fas fa-check-circle"></em> {{ selectedPartArray.length }}
    </span>
    <button type="button" class="btn btn-secondary" (click)="OnClose()" aria-label="Center Align"
        translate>lblClose</button>
    <button type="button" class="btn btn-primary" aria-label="Center Align" (click)="onSaveItems()"
        translate>lblAdd</button>
</div>

<ng-template #contentAdditional let-modal>
    <div class="modal-header">
        <h2 class="modal-title" translate>lblAdditionalPart <em
                class="fas fa-long-arrow-alt-right"></em>{{selectedPart.partNumber}}</h2>
        <button type="button" class="close" aria-label="Close" (click)="modal.dismiss(false)">
            <span aria-hidden="true">×</span>
        </button>
    </div>
    <div class="modal-body p-0 ">
        <div class="card  pad15 border">
            <div class="row">
                <div class="col">
                    <div class="af-form-group">
                        <label translate>lblMake</label>
                        <div class="lbl-info">{{selectedPart.makeCode}}</div>
                    </div>
                </div>
                <div class="col">
                    <div class="af-form-group">
                        <label translate>lblLocationName</label>
                        <div class="lbl-info">{{selectedPart.locationCode}} {{selectedPart.locationName}}</div>
                    </div>
                </div>
                <div class="col-2">
                    <div class="af-form-group">
                        <label translate>lblDescription</label>
                        <div class="lbl-info">{{selectedPart.description}}</div>
                    </div>
                </div>
                <div class="col text-right">
                    <div class="af-form-group">
                        <label translate>lblPrice</label>
                        <div class="lbl-info">{{selectedPart.unitPrice |number: '1.2-2'}}</div>
                    </div>
                </div>
                <div class="col text-right">
                    <div class="af-form-group">
                        <label translate>lblPriceInc</label>
                        <div class="lbl-info">{{selectedPart.unitPriceInclVat |number: '1.2-2'}}</div>
                    </div>
                </div>
                <div class="col text-right">
                    <div class="af-form-group">
                        <label translate>lblTotalQty</label>
                        <div class="lbl-info">{{selectedPart.quantity}}</div>
                    </div>
                </div>
                <div class="col text-right">
                    <div class="af-form-group">
                        <label translate>lblAvlQty</label>
                        <div class="lbl-info">{{selectedPart.availableQuantity}}</div>
                    </div>
                </div>
            </div>
        </div>
        <div class="pad15">
            <div class="table-responsive">
                <table class="tablest1">
                    <thead>
                        <tr>
                            <th scope="col" style="width: 20px" class="pl-1" translate></th>
                            <th scope="col" translate>lblMake</th>
                            <th scope="col" translate>lblLocationName</th>
                            <th scope="col" translate>lblPartNumber</th>
                            <th scope="col" translate>lblDescription</th>
                            <th scope="col" class="text-right" translate>lblPrice</th>
                            <th scope="col" class="text-right" translate>lblPriceInc</th>
                            <th scope="col" class="text-right" translate>lblUnitCost</th>
                            <th scope="col" class="text-right" translate>lblTotalQty</th>
                            <th scope="col" class="text-right" translate>lblAvlQty</th>
                        </tr>
                    </thead>
                    <tbody>
                        <ng-container *ngIf="addtionalPartsList?.length>0; else load_NotFound_Add_Template">
                            <ng-container *ngFor="let part of addtionalPartsList; let i=index">
                                <tr [ngClass]="{'bg-info': part.expanded}">
                                    <td (click)="part.expanded = !part.expanded" class="pl-1">
                                        <a class="btn btn-ico" ngbTooltip="Check Availability"
                                            (click)="getAdditionalPartLocation(part.partNumber,i)"
                                            tooltipClass="custom-revert" container="body">
                                            <em class="fas fa-check-circle fa-lg text-success"
                                                [ngClass]="{'fa-chevron-up': part.expanded}"></em>
                                        </a>
                                    </td>
                                    <td>
                                        <ngb-highlight [result]="part.makeCode">
                                        </ngb-highlight>
                                    </td>
                                    <td>
                                        {{part.locationCode}} {{part.locationName}}
                                    </td>
                                    <td>
                                        <ngb-highlight [result]="part.partNumber">
                                        </ngb-highlight>
                                    </td>
                                    <td>
                                        <ngb-highlight [innerHTML]="part.description">
                                        </ngb-highlight>
                                    </td>
                                    <td class="text-right">
                                        <ngb-highlight [result]="part.unitPrice |number: '1.2-2'">
                                        </ngb-highlight>
                                    </td>
                                    <td class="text-right">
                                        <ngb-highlight [result]="part.unitPriceInclVat |number: '1.2-2'">
                                        </ngb-highlight>
                                    </td>
                                    <td class="text-right">
                                        <ngb-highlight [result]="part.unitCost |number: '1.2-2'">
                                        </ngb-highlight>
                                    </td>
                                    <td class="text-right">
                                        <ngb-highlight [result]="part.quantity |number: '1.2-2'">
                                        </ngb-highlight>
                                    </td>
                                    <td class="text-right">
                                        <ngb-highlight [result]="part.availableQuantity |number: '1.2-2'">
                                        </ngb-highlight>
                                    </td>
                                </tr>
                                <tr class="table-active" *ngIf="part.expanded">
                                    <td colspan="12" class="p-2 pl47">
                                        <table class="tablest1 border">
                                            <thead>
                                                <tr>
                                                    <th scope="col" translate>lblMake</th>
                                                    <th scope="col" translate>lblLocationName</th>
                                                    <th scope="col" translate>lblPartNumber</th>
                                                    <th scope="col" translate>lblDescription</th>
                                                    <th scope="col" class="text-right" translate>lblPrice</th>
                                                    <th scope="col" class="text-right" translate>lblPriceInc</th>
                                                    <th scope="col" class="text-right" translate>lblUnitCost</th>
                                                    <th scope="col" class="text-right" translate>lblTotalQty</th>
                                                    <th scope="col" class="text-right" translate>lblAvlQty</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <ng-container
                                                    *ngIf="part.partLocationList?.length>0; else load_NotFoundPartLocations_Template">
                                                    <ng-container
                                                        *ngFor="let loc of part.partLocationList; let j=index">
                                                        <tr>
                                                            <td>
                                                                <ngb-highlight [result]="loc.makeCode">
                                                                </ngb-highlight>
                                                            </td>
                                                            <td>
                                                                {{loc.locationCode}} {{loc.locationName}}
                                                            </td>
                                                            <td>
                                                                <ngb-highlight [result]="loc.partNumber">
                                                                </ngb-highlight>
                                                            </td>
                                                            <td>
                                                                <ngb-highlight [innerHTML]="loc.description">
                                                                </ngb-highlight>
                                                            </td>
                                                            <td class="text-right">
                                                                <ngb-highlight
                                                                    [result]="loc.unitPrice |number: '1.2-2'">
                                                                </ngb-highlight>
                                                            </td>
                                                            <td class="text-right">
                                                                <ngb-highlight
                                                                    [result]="loc.unitPriceInclVat |number: '1.2-2'">
                                                                </ngb-highlight>
                                                            </td>
                                                            <td class="text-right">
                                                                <ngb-highlight [result]="loc.unitCost |number: '1.2-2'">
                                                                </ngb-highlight>
                                                            </td>
                                                            <td class="text-right">
                                                                <ngb-highlight [result]="loc.quantity |number: '1.2-2'">
                                                                </ngb-highlight>
                                                            </td>
                                                            <td class="text-right">
                                                                <ngb-highlight
                                                                    [result]="loc.availableQuantity |number: '1.2-2'">
                                                                </ngb-highlight>
                                                            </td>
                                                        </tr>
                                                    </ng-container>
                                                </ng-container>
                                                <ng-template #load_NotFoundPartLocations_Template>
                                                    <tr>
                                                        <td colspan="8" class="no-record" translate>
                                                            lblNoRecordsFound</td>
                                                    </tr>
                                                </ng-template>
                                            </tbody>
                                        </table>
                                    </td>
                                </tr>
                            </ng-container>
                        </ng-container>
                        <ng-template #load_NotFound_Add_Template>
                            <tr>
                                <td colspan="8" class="no-record" translate>lblNoRecordsFound</td>
                            </tr>
                        </ng-template>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-secondary" (click)="modal.dismiss(false)" aria-label="Center Align"
            translate>lblClose</button>
    </div>
</ng-template>